import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { DATE_TIME_FORMAT } from '../../constants';
import getCarrier from '../../helpers/getCarrier';
import { splitLongText } from 'helpers/text';
import {
  getPrettyPlanCarrier,
  getSubStatus,
  needToShowPlanCarrier,
} from 'helpers/subs';

class OrderedSubList extends React.Component {
  headers = [
    { label: 'ID', key: 'id', styles: { minWidth: '50px' } },
    { label: 'First Name', key: 'first_name', styles: { minWidth: '100px' } },
    { label: 'Last Name', key: 'last_name', styles: { minWidth: '100px' } },
    {
      label: this.props.identifierTitle
        ? 'Identifier'
        : this.props.isSimo
          ? 'Device SN'
          : 'MDN',
      key: this.props.isSimo ? 'device_sn' : 'mdn',
      ordered: true,
      styles: { minWidth: '100px' },
    },
    { label: 'Carrier', key: 'carrier', ordered: false },
    { label: 'Status', key: this.props.statusKey },
    {
      label: (
        <>
          Effective
          <br />
          Date
        </>
      ),
      key: 'effective_date',
    },
    { label: 'User ID', key: 'user_profile', styles: { minWidth: '77px' } },
    { label: 'Agent', key: 'agent_name', styles: { minWidth: '70px' } },
    {
      label: 'Vendor',
      key: 'vendor',
      ordered: false,
      styles: { minWidth: '70px' },
    },
    {
      label: 'Plan Name',
      key: '',
      ordered: false,
      styles: { minWidth: '100px' },
    },
    { label: '', key: 'view', ordered: false },
  ];

  handleChangeFilter = (orderKey, ordered) => {
    const { ordering, changeOrdering, notOrderedKeys = [] } = this.props;

    if (ordered === null || ordered === false) {
      return;
    } // ordering doesn't exists
    if (notOrderedKeys.includes(orderKey)) {
      return true;
    } // odering for this key disabled

    const prevOrderKey = ordering[0] === '-' ? ordering.slice(1) : ordering;

    const filter =
      orderKey === prevOrderKey && ordering[0] === '-'
        ? orderKey
        : `-${orderKey}`;

    changeOrdering(filter);
  };

  renderHeader = ({ key, label, ordered, styles = {} }) => {
    const { ordering, notOrderedKeys = [], isQuick } = this.props;
    const orderKey = ordering[0] === '-' ? ordering.slice(1) : ordering;

    if (!isQuick && key === 'vendor') {
      return null;
    }

    return (
      <th
        key={key}
        onClick={() => this.handleChangeFilter(key, ordered)}
        className={
          key && !notOrderedKeys.includes(key) && ordered !== false
            ? 'order-header'
            : ''
        }
        style={styles}
      >
        {label}
        {orderKey === key ? (ordering[0] === '-' ? ' ↓' : ' ↑') : null}
      </th>
    );
  };

  renderHeaders = () => {
    const { showEffectiveDate = false, showCarrier = false } = this.props;
    const additionalKeys = {
      effective_date: showEffectiveDate,
      carrier: showCarrier,
    };

    return (
      <tr>
        {this.headers.map((header) =>
          additionalKeys[header.key] !== undefined
            ? additionalKeys[header.key]
              ? this.renderHeader(header)
              : null
            : this.renderHeader(header),
        )}
      </tr>
    );
  };

  renderPlanName = (sub, carrier) => {
    if (carrier === 'simo') {
      return sub?.plan?.display_name || sub?.plan?.name;
    } else {
      return sub?.plan?.name;
    }
  };

  render() {
    const {
      subs,
      viewUrl,
      actionComponent,
      showEffectiveDate,
      showCarrier,
      isQuick,
      identifierTitle,
    } = this.props;

    return (
      <div>
        <table className="table">
          <thead>{this.renderHeaders()}</thead>
          <tbody>
            {subs.length > 0 ? (
              subs.map((sub) => {
                const carrier = getCarrier(sub);
                const subStatus = getSubStatus(sub);
                return (
                  <tr key={`${carrier}_${sub.id}`}>
                    <td>{sub.id}</td>
                    <td>{splitLongText(sub.first_name)}</td>
                    <td>{splitLongText(sub.last_name)}</td>
                    <td>
                      {identifierTitle
                        ? sub.device_sn || sub.mdn
                        : this.props.isSimo
                          ? sub.device_sn
                          : sub.mdn}
                    </td>
                    {showCarrier && <td>{carrier}</td>}
                    <td>{subStatus}</td>
                    {showEffectiveDate && (
                      <td>
                        {sub.effective_date
                          ? moment(sub.effective_date).format(DATE_TIME_FORMAT)
                          : ''}
                      </td>
                    )}
                    <td>{sub.user_profile}</td>
                    <td>{sub.agent_name && sub.agent_name.split(' ')[0]}</td>
                    {isQuick && <td>{sub.vendor}</td>}
                    <td>
                      {needToShowPlanCarrier(sub, sub?.plan?.plan_carrier) && (
                        <span>
                          {getPrettyPlanCarrier(sub?.plan?.plan_carrier)}{' '}
                        </span>
                      )}
                      {this.renderPlanName(sub, carrier)}
                    </td>
                    <td>
                      {actionComponent ? (
                        actionComponent(sub)
                      ) : (
                        <Link to={viewUrl(sub.id)}>View</Link>
                      )}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td>No Results</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

export default OrderedSubList;

OrderedSubList.defaultProps = { notOrderedKeys: [] };
